/* eslint-disable function-paren-newline */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, DatePicker, Select, Button, message, Spin } from 'antd';
import validationRegex from '../utils/validationRegex';

import CMP_QUERY from '../graphql/queries/getCustomerManagementPersonsQuery.graphql';
import QUERIES from '../graphql/queries/customerCreateQueries.graphql';
import MUTATION from '../graphql/mutations/storeCustomerAssociateConcernMutation.graphql';
import ALL_QUERY from '../graphql/queries/getCustomerAssociateConcernsQuery.graphql';

const FormItem = Form.Item;
const { Option } = Select;

class AssociateConcernForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, { customer_management_persons, ...values }) => {
      const { customer_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { customer_id, ...values, customer_management_persons: JSON.stringify(customer_management_persons) },
          update: (cache, { data: { newAssociateConcern } }) => {
            const data = cache.readQuery({
              query: ALL_QUERY,
              variables: { customer_id },
            });
            if (!Array.isArray(data.associateConcerns)) data.associateConcerns = [];
            data.associateConcerns.push(newAssociateConcern);
            cache.writeQuery({ query: ALL_QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading: l1, sectors, constitutions } = this.props.basicDetailsQuery;
    const { loading: l2, managementPersons } = this.props.customerManagementPersonsQuery;
    if (l1 || l2) {
      return (
        <Spin size="large" />
      );
    }
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          hasFeedback
          label="Customer Name"
        >
          {
            getFieldDecorator(
              'name',
              {
                rules: [
                  {
                    required: true,
                    type: 'string',
                    message: 'Name is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Constitution"
          style={{ width: 230 }}
        >
          {
            getFieldDecorator(
              'constitution_id',
              {
                rules: [
                  {
                    required: true,
                    message: 'Constitution is required!',
                  },
                ],
              },
            )(<Select placeholder="Select one">{ constitutions.map((constitution) => (<Option value={constitution.id} key={constitution.id}>{constitution.name}</Option>)) }</Select>)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Sector"
          style={{ width: 160 }}
        >
          {
            getFieldDecorator(
              'sector_id',
              {
                rules: [
                  {
                    required: true,
                    message: 'Sector is required!',
                  },
                ],
              },
            )(<Select placeholder="Select one">{ sectors.map((sector) => (<Option value={sector.id} key={sector.id}>{sector.name}</Option>)) }</Select>)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Sub Sector"
        >
          {
            getFieldDecorator(
              'sub_sector',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Line of activity"
        >
          {
            getFieldDecorator(
              'line_of_activity',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Landline no."
        >
          {
            getFieldDecorator(
              'landline',
              {
                rules: [
                  {
                    pattern: validationRegex.landline,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input placeholder="With STD code & start with 0" />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Email address"
        >
          {
            getFieldDecorator(
              'email',
              {
                rules: [
                  {
                    type: 'email',
                    message: 'Incorrect email entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Website"
          hasFeedback
        >
          {
            getFieldDecorator(
              'website',
              {
                rules: [
                  {
                    type: 'url',
                    message: 'Incorrect website entered!',
                  },
                ],
              },
            )(<Input placeholder="Format: http://bizminder.co.in" />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="PAN no."
        >
          {
            getFieldDecorator(
              'pan_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'PAN no. is required!',
                  },
                  {
                    pattern: validationRegex.pan_no,
                    message: 'Incorrect PAN!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Date of formation"
        >
          {
            getFieldDecorator(
              'formation_date',
              {
                rules: [
                  {
                    required: true,
                    message: 'Date is required!',
                  },
                ],
              },
            )(<DatePicker />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Management team (from customer)"
        >
          {
            getFieldDecorator(
              'customer_management_persons',
              {
                rules: [
                  {
                    required: true,
                    message: 'Atleast one should be selected!',
                  },
                ],
              },
            )(
              <Select
                mode="multiple"
                placeholder="Please select management people from current customer"
                style={{ width: 400 }}
              >
                {
                  managementPersons.map((entry) => (
                    <Option key={entry.id} value={entry.id}>{`${entry.first_name} ${entry.middle_name} ${entry.last_name}`}</Option>
                  ))
                }
              </Select>,
            )
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

AssociateConcernForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  basicDetailsQuery: PropTypes.shape({
    constitutions: PropTypes.array,
    sectors: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  customerManagementPersonsQuery: PropTypes.shape({
    managementPersons: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(CMP_QUERY, {
    name: 'customerManagementPersonsQuery',
    options: ({ customer_id }) => ({ variables: { customer_id } }),
  }),
  graphql(QUERIES, {
    name: 'basicDetailsQuery',
  }),
  graphql(MUTATION),
  Form.create(),
)(AssociateConcernForm);



// WEBPACK FOOTER //
// ./src/forms/AssociateConcernForm.jsx